<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :useFieldInfo="true"
      :types="['field_name', '부서명_과', 'com_name', 'manager_name']"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
    />

    <table-inspect-merge
      class="mt-28px"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      v-model="form.inspectList"
      title="밀폐공간 작업 질식재해 예방 자체점검표"
      contentBefore="•"
      table-header-title="평가항목"
      :table-header-note="[{ text: '비고', width: '300' }]"
      :table-header-check="[
        { text: '양호', value: 'Yes', width: '100' },
        { text: '미흡', value: 'No', width: '100' },
        { text: '해당없음', value: 'N/A', width: '100' },
      ]"
    />

    <!-- 점검자 -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="점검자"
      :tableData="[
        { id: '부서', title: '부서', type: 'text', placeholder: '' },
        { id: '직책', title: '직책', type: 'text', placeholder: '' },
        { id: '성명', title: '성명', type: 'text', placeholder: '' },
        { id: '서명', title: '서명', type: 'sign', placeholder: '' },
      ]"
      :mobile="['target', 'name']"
      v-model="form.점검자"
      class="mt-4"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "../../../../components/selector/DateSelectorRang.vue";
import FieldSelector from "../../../../components/selector/FieldSelector.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "./inspectData";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  components: {
    RadioGroup,
    TableCustom,
    SignField,
    NameWithSignatureRow,
    PhotoUploadGridModule,
    TableInspectMerge,
    FieldSelector,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        inspectList: inspectData.inspectTable,
        점검자: [],
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
